import useChecklistAnnouncerStore from '../../store/checklist-announcer';

/**
 * The checklist's live region, mounted once in the shell and never unmounted: `Hide` unmounts
 * the card, and a region removed with its message is never read.
 */
export function ChecklistAnnouncer(): JSX.Element {
  const message = useChecklistAnnouncerStore((state) => state.message);
  const nonce = useChecklistAnnouncerStore((state) => state.nonce);

  return (
    <div role="status" aria-live="polite" aria-atomic="true" className="sr-only" data-testid="checklist-announcer">
      {/* Keyed on the nonce so an identical repeat still replaces the node and is read again. */}
      <span key={nonce}>{message}</span>
    </div>
  );
}
